import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import * as S from './styled'

const SelectFilter = ({
    label,
    options,
    isMulti = false,
    column,
    onApplyFilters,
    state,
    gotoPage,
    selectedFilters = [],
    defaultFilters,
}) => {
    const [selectedOptions, setSelectedOptions] = useState([])

    const path = window.location.pathname
    const claims = window.localStorage.getItem('claims')
    const user = claims ? JSON.parse(claims)['id'] : ''

    let defaultOptions = []

    if (defaultFilters && defaultFilters[column.id]) {
        defaultOptions = options.filter(option => defaultFilters[column.id].includes(option.value))
    }

    useEffect(() => {
        let storedFilters = JSON.parse(window.localStorage.getItem(`${user}_filterValues${path}`))

        if (storedFilters && storedFilters[column.id]) {
            const storedOptions = options.filter(option =>
                storedFilters[column.id].includes(option.value)
            )
            setSelectedOptions(storedOptions)
        } else if (defaultFilters) {
            setSelectedOptions(defaultOptions)
        }
    }, [])

    useEffect(() => {
        if (isMulti) {
            column.setFilter(selectedOptions.map(opt => opt.value))
        } else {
            if (
                selectedOptions &&
                JSON.stringify(selectedOptions) !== JSON.stringify(defaultOptions)
            ) {
                column.setFilter(selectedOptions.value)
            }
        }
    }, [selectedOptions])

    useEffect(() => {
        // Clear filters on reset
        const hasOptions = isMulti
            ? selectedOptions.length > 0
            : Object.keys(selectedOptions).length > 0
        if (hasOptions && Object.keys(state[0].filters).length === 0) {
            setSelectedOptions(defaultOptions)
        }
    }, [state[0].filters])

    return (
        <>
            {selectedFilters[column.id] && (
                <S.SelectFilter>
                    <label>{label}</label>
                    <div data-testid={`select-filter-${label.toLowerCase().replaceAll(' ', '-')}`}>
                        <Select
                            className="!w-full"
                            classNamePrefix="list"
                            value={selectedOptions}
                            onChange={opt => {
                                if (!opt) opt = []
                                setSelectedOptions(opt)
                            }}
                            onBlur={() => {
                                onApplyFilters()
                                gotoPage(0)
                            }}
                            options={options}
                            isMulti={isMulti}
                        />
                    </div>
                </S.SelectFilter>
            )}
        </>
    )
}

SelectFilter.propTypes = {
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    column: PropTypes.shape({
        filterValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        setFilter: PropTypes.func.isRequired,
    }),
    onApplyFilters: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    defaultFilters: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
}

export default SelectFilter
